// @flow
import { combineReducers } from 'redux';

import { campaignReducer, campaignInitialState } from './campaignReducer';
import { categoriesReducer, categoriesInitialState } from './categoriesReducer';
import { cartReducer, cartInitialState } from './cartReducer';
import { productsReducer, productsInitialState } from './productsReducer';
import { userReducer, userInitialState } from './userReducer';
import { viewReducer, viewInitialState } from './viewReducer';
import { sortReducer, sortInitialState } from './sortReducer';
import { searchReducer, searchInitialState } from './searchReducer';
import { customizeReducer, customizeInitialState } from './customizeReducer';
import { adminReducer, adminInitialState } from './adminReducer';
import { abTestReducer, abTestInitialState } from './abTestReducer';
import { invoicesReducer, invoicesInitialState } from './invoicesReducer';
import { optimizelyReducer, optimizelyInitialState } from './optimizelyReducer';
import {
  socialEcommReducer,
  socialEcommInitialState,
} from './socialEcommReducer';

import type { CampaignState } from './campaignReducer';
import type { CategoriesState } from './categoriesReducer';
import type { ViewState } from './viewReducer';
import type { ProductsState } from './productsReducer';
import type { CartState } from './cartReducer';
import type { UserState } from './userReducer';
import type { SortState } from './sortReducer';
import type { CustomizeState } from './customizeReducer';
import type { AdminState } from './adminReducer';
import type { Action } from '../services/actions/Action.type';
import type { AbTestState } from './abTestReducer';
import type { InvoicesState } from './invoicesReducer';
import type { OptimizelyState } from './optimizelyReducer';

export const initialState = {
  campaignState: campaignInitialState,
  categoriesState: categoriesInitialState,
  viewState: viewInitialState,
  productsState: productsInitialState,
  cartState: cartInitialState,
  userState: userInitialState,
  sortState: sortInitialState,
  searchState: searchInitialState,
  customizeState: customizeInitialState,
  adminState: adminInitialState,
  abTestState: abTestInitialState,
  invoicesState: invoicesInitialState,
  optimizelyState: optimizelyInitialState,
  socialEcommState: socialEcommInitialState,
};

export type State = {
  abTestState: AbTestState,
  campaignState: CampaignState,
  categoriesState: CategoriesState,
  cartState: CartState,
  productsState: ProductsState,
  userState: UserState,
  viewState: ViewState,
  sortState: SortState,
  searchState: SearchState,
  customizeState: CustomizeState,
  adminState: AdminState,
  invoicesState: InvoicesState,
  optimizelyState: OptimizelyState,
};

const reducers = {
  campaignState: campaignReducer,
  categoriesState: categoriesReducer,
  cartState: cartReducer,
  productsState: productsReducer,
  sortState: sortReducer,
  searchState: searchReducer,
  userState: userReducer,
  viewState: viewReducer,
  customizeState: customizeReducer,
  adminState: adminReducer,
  abTestState: abTestReducer,
  invoicesState: invoicesReducer,
  optimizelyState: optimizelyReducer,
  socialEcommState: socialEcommReducer,
};

export default combineReducers<typeof reducers, Action>(reducers);
